const heroImage =
  "https://readdy.ai/api/search-image?query=airy%20warm%20flat%20vector%20illustration%20background%20with%20playful%20scattered%20doodles%20of%20speech%20bubbles%2C%20letter%20envelopes%2C%20coffee%20cups%2C%20open%20books%2C%20stars%20and%20little%20hearts%2C%20soft%20cream%20background%20with%20coral%20red%20and%20gold%20accents%2C%20light%20airy%20and%20friendly%20campus%20community%20mood%2C%20subtle%20grain&width=1800&height=760&seq=hero-campus-01&orientation=landscape";

const stats = [
  { value: "1280+", label: "今日新投稿" },
  { value: "860+", label: "参与高校" },
  { value: "5.4万+", label: "树洞已收录" },
];

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden">
      <div className="absolute inset-0 -z-10">
        <img
          src={heroImage}
          alt="暖色手绘风格的校园树洞投稿插图背景"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/80 via-background-50/55 to-background-50" />
      </div>

      <div className="mx-auto flex min-h-[560px] w-full max-w-5xl flex-col items-center justify-center px-4 pb-14 pt-16 text-center md:min-h-[620px] md:pb-20 md:pt-20">
        <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-background-50/80 px-4 py-1.5 text-xs font-medium text-primary-700">
          <i className="ri-shield-check-line" aria-hidden="true" />
          安全 · 匿名 · 友善的表达出口
        </span>

        <h1 className="mt-6 max-w-3xl font-heading text-4xl leading-tight font-semibold text-foreground-950 md:text-6xl">
          想说又不想露脸的话，
          <span className="relative text-primary-600">
            这里都替你收着
            <span
              className="absolute -bottom-2 left-0 h-3 w-full rounded-full bg-accent-300/70"
              aria-hidden="true"
            />
          </span>
        </h1>

        <p className="mt-6 max-w-2xl text-base leading-relaxed text-foreground-700 md:text-lg">
          校园吃瓜网是面向大学生的匿名树洞与投稿箱。身边趣事、日常吐槽、被暖到的瞬间——
          不用露脸也能安心说，吃瓜更要安全说。投稿箱随时开启，想投就投。
        </p>

        <div className="mt-8 flex w-full flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href="#submit"
            className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-full bg-primary-500 px-8 py-3.5 text-base font-medium text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
          >
            <i className="ri-send-plane-fill mr-2" aria-hidden="true" />
            匿名投稿
          </a>
          <a
            href="#hot"
            className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-full border border-background-300 bg-background-50/80 px-8 py-3.5 text-base font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700 sm:w-auto"
          >
            逛逛今日热帖
          </a>
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-xs text-foreground-600 md:text-sm">
          <span className="inline-flex items-center gap-1.5">
            <i className="ri-lock-line text-primary-500" aria-hidden="true" />无需注册
          </span>
          <span className="inline-flex items-center gap-1.5">
            <i className="ri-message-3-line text-primary-500" aria-hidden="true" />小编 24h 审核上墙
          </span>
          <span className="inline-flex items-center gap-1.5">
            <i className="ri-sparkling-line text-primary-500" aria-hidden="true" />只聊事，不聊人
          </span>
        </div>
      </div>

      <div className="mx-auto w-full max-w-5xl px-4 pb-16 md:px-8">
        <div className="grid grid-cols-3 gap-3 rounded-2xl border border-background-200 bg-background-50/70 px-5 py-5 backdrop-blur-sm md:gap-4 md:px-8 md:py-6">
          {stats.map((s) => (
            <div key={s.label} className="text-center">
              <p className="font-heading text-2xl font-semibold text-primary-600 md:text-4xl">
                {s.value}
              </p>
              <p className="mt-1 text-xs text-foreground-600 md:text-sm">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}